const SCROLLABLE = new Set(['auto', 'scroll', 'overlay'])

/**
 * 縦にスクロールする一番近い祖先を返す。無ければ null（ビューポートがスクロールする）。
 * IntersectionObserver の root に渡して、置かれた場所に関係なく無限スクロールを判定するために使う。
 */
export const findScrollParent = (element: Element | null): HTMLElement | null => {
  let node = element?.parentElement ?? null
  while (node) {
    if (SCROLLABLE.has(getComputedStyle(node).overflowY)) return node
    node = node.parentElement
  }
  return null
}
